/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {REQUEST_CITY, REQUEST_CITY_FAILURE, REQUEST_CITY_SUCCESS} from "../../constant/postal-code/PostalCodeConstant";

const initialState = {
    postalCode: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const cityReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_CITY:
            return {
                ...state,
                postalCode: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_CITY_SUCCESS:
            return {
                ...state,
                postalCode: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_CITY_FAILURE:
            return {
                ...state,
                postalCode: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
